<script>
    import { Route } from 'svelte-navigator';
    import PublicRouteGuard from '../guards/PublicRouteGuard.svelte';
    
    export let path;
</script>

<Route exact {path} let:params let:location let:navigate>
    <!-- <PublicRouteGuard> -->
        <slot {params} {location} {navigate} />
    <!-- </PublicRouteGuard> -->
</Route>